module.exports = __webpack_public_path__ + "media/vogue-7929d208.svg";